export const GoogleV2Icon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3030_10932)">
        <path
          d="M20.3799 4.13021L17.4699 6.87021C16.6721 6.01811 15.6861 5.36427 14.5907 4.96088C13.4953 4.55749 12.3208 4.41571 11.1609 4.54685C10.001 4.678 8.88774 5.07844 7.91006 5.71623C6.93239 6.35401 6.11731 7.21148 5.52988 8.22021L2.37988 5.72021C3.32914 4.26092 4.59786 3.03662 6.09004 2.13995C7.58223 1.24327 9.2588 0.69771 10.9929 0.544529C12.727 0.391349 14.4733 0.634563 16.0996 1.25577C17.7258 1.87698 19.1895 2.85992 20.3799 4.13021Z"
          fill="#131313"
          stroke="#131313"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.57005 15.8402L2.56005 18.5502C1.25041 16.6749 0.533213 14.45 0.501126 12.1628C0.469038 9.87572 1.12354 7.63153 2.38005 5.72021L5.53005 8.22022C4.84896 9.37591 4.49309 10.6943 4.50013 12.0357C4.50717 13.3772 4.87686 14.6917 5.57005 15.8402Z"
          fill="#131313"
          stroke="#131313"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1401 21.0298C17.9066 22.002 16.4873 22.7114 14.9694 23.1143C13.4516 23.5173 11.8673 23.6054 10.3141 23.373C8.76091 23.1407 7.27172 22.593 5.9382 21.7635C4.60467 20.934 3.45503 19.8403 2.56006 18.5498L5.57006 15.8398C6.10646 16.7394 6.82532 17.5167 7.68035 18.1215C8.53537 18.7264 9.50761 19.1455 10.5344 19.3518C11.5613 19.5581 12.6199 19.5471 13.6422 19.3194C14.6646 19.0917 15.6278 18.6524 16.4701 18.0298L19.1401 21.0298Z"
          fill="#131313"
          stroke="#131313"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.5 10.5V12.6C23.415 14.2345 22.9821 15.832 22.2302 17.2858C21.4783 18.7395 20.4248 20.016 19.14 21.03L16.47 18.03C17.6805 17.1456 18.5941 15.9147 19.09 14.5H13.5V10.5H23.5Z"
          fill="#131313"
          stroke="#131313"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.38012 5.71996L2.37012 5.70996"
          stroke="#131313"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5598 18.5498L2.5498 18.5598"
          stroke="#131313"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.57982 15.8301L5.56982 15.8401"
          stroke="#131313"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3030_10932">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
